import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TimeInputMinuteStep } from 'utils';

/**
 * Minute step of a time input: the org-wide setting (Settings → System Preferences, `company.timeInputMinuteStep`)
 * unless `override` is given for an input that needs every minute listed. Returns the step and the minutes the picker
 * lists. It only limits the picker — a typed minute (e.g. 17) is always accepted.
 */
export const useTimeInputMinuteStep = (override) => {
    const orgMinuteStep = useSelector((state) => state.system.company?.timeInputMinuteStep);
    const step = override || orgMinuteStep || TimeInputMinuteStep.REGULAR;
    const minutes = useMemo(() => Array.from({ length: 60 / step }, (_, i) => String(i * step).padStart(2, '0')), [step]);
    return { step, minutes };
};
